import React from 'react'
import PropTypes from 'prop-types'

import s from './ModalFooter.scss'


const ModalFooter = ({ children }) => (
  <div className={s.modalFooter}>
    {children}
  </div>
)

ModalFooter.propTypes = {
  children: PropTypes.any.isRequired,
}


export default ModalFooter
